import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ModalResult from '../Components/ModalResult';

class ModalResultContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { modalResult } = this.props;
        return (
            <Fragment>
                {modalResult && modalResult.isEnabled && modalResult.isVisible ?
                    <ModalResult {...modalResult} /> : null
                }
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalResult: state.modalResult
    };

}

export default connect(mapStateToProps)(ModalResultContainer);